import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class SeasonPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.seasonRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.seasonImport,
    );
    this.seasonAutocomplete = permissionChecker.match(
      Permissions.values.seasonAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.seasonCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.seasonEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.seasonDestroy,
    );
  }
}
